import React from 'react';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';

const breadcrumbConfig = [
  {
    key: 'channelSetting',
    breadcrumbName: $i18n.get({ id: 'aopf.src.menuConfig.AppSettings', dm: '应用设置' }),
    path: '/channelSetting',
  },
];
const Header: React.FC = () => {
  return (
    <div>
      <CommonHeader
        title={$i18n.get({ id: 'aopf.src.menuConfig.AppSettings', dm: '应用设置' })}
        // backTo={`/overview${location.search}`}
        breadcrumbs={breadcrumbConfig}
      />
    </div>
  );
};
export default Header;
